import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../services/admin/admin.service';
import { ApiServiceService } from '../../../services/common/api-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-verification-manager',
  templateUrl: './verification-manager.component.html',
  styleUrls: ['./verification-manager.component.scss']
})
export class VerificationManagerComponent implements OnInit {
  queue: any[] = [];
  loading = false;
  selectedAadhaarUrl: any = null;
  selectedUser: any = null;
  zoomLevel = 1.0;
  imageError = false;
  base64Images: { [profileId: string]: string } = {};
  photoLightboxUrl: string | null = null;


  constructor(
    private adminService: AdminService,
    private apiService: ApiServiceService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.loadQueue();
  }

  loadQueue(): void {
    this.loading = true;
    this.adminService.getVerificationQueue().subscribe({
      next: (resp) => {
        this.loading = false;
        if (resp.status === 'success') {
          this.queue = resp.data;
          this.loadProfileImages();
        }
      },
      error: (err) => {
        this.loading = false;
        console.error('Error loading queue:', err);
      }
    });
  }

  loadProfileImages(): void {
    this.queue.forEach(user => {
      const avatarId = user.personal_info?.avatar_Id;
      if (avatarId) {
        const idKey = user.basic_info?.keycloak_id || user.basic_info?.ory_identity_id || user._id;
        const imgPath = `${idKey}/gallery/avatar/${avatarId}`;
        this.apiService.getImageBase64(imgPath).subscribe({
          next: (resp: any) => {
            if (resp && resp.base64Image) {
              const b64 = resp.base64Image;
              this.base64Images[user._id] = b64.startsWith('data:') ? b64 : `data:image/jpeg;base64,${b64}`;
            }
          },
          error: (err: any) => console.error('Error loading profile image:', err)
        });
      }
    });
  }

  viewAadhaar(user: any): void {
    this.selectedUser = user;
    this.zoomLevel = 1.0;
    this.imageError = false;
    const token = localStorage.getItem('weddingly_admin_token') || '';
    const rawUrl = `${environment.apiUrl}/admin/verifications/${user._id}/aadhaar?Authorization=${encodeURIComponent(token)}`;
    this.selectedAadhaarUrl = this.sanitizer.bypassSecurityTrustResourceUrl(rawUrl);

    if (!this.base64Images[user._id] && user.personal_info?.avatar_Id) {
      const idKey = user.basic_info?.keycloak_id || user.basic_info?.ory_identity_id || user._id;
      const imgPath = `${idKey}/gallery/avatar/${user.personal_info.avatar_Id}`;
      this.apiService.getImageBase64(imgPath).subscribe({
        next: (resp: any) => {
          if (resp && resp.base64Image) {
            const b64 = resp.base64Image;
            this.base64Images[user._id] = b64.startsWith('data:') ? b64 : `data:image/jpeg;base64,${b64}`;
          }
        },
        error: (err: any) => console.error('Error loading profile image inside modal:', err)
      });
    }
  }

  closePreview(): void {
    this.selectedAadhaarUrl = null;
    this.selectedUser = null;
    this.zoomLevel = 1.0;
    this.imageError = false;
  }

  approve(profileId: string): void {
    Swal.fire({
      title: 'Approve Verification?',
      text: 'This will mark the user profile as Verified.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Approve',
      confirmButtonColor: '#198754',
      didOpen: () => {
        const container = document.querySelector('.swal2-container') as HTMLElement;
        if (container) container.style.zIndex = '99999';
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.adminService.approveVerification(profileId).subscribe({
          next: () => {
            Swal.fire({ title: 'Approved', text: 'Profile has been verified.', icon: 'success',
              didOpen: () => { const c = document.querySelector('.swal2-container') as HTMLElement; if (c) c.style.zIndex = '99999'; }
            });
            this.loadQueue();
            this.closePreview();
          },
          error: (err) => Swal.fire('Error', err.error?.message || 'Action failed', 'error')
        });
      }
    });
  }

  reject(profileId: string): void {
    Swal.fire({
      title: 'Reject Verification?',
      text: 'This will mark the verification status as Rejected.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Reject',
      confirmButtonColor: '#dc3545',
      didOpen: () => {
        const container = document.querySelector('.swal2-container') as HTMLElement;
        if (container) container.style.zIndex = '99999';
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.adminService.rejectVerification(profileId).subscribe({
          next: () => {
            Swal.fire({ title: 'Rejected', text: 'Verification request rejected.', icon: 'success',
              didOpen: () => { const c = document.querySelector('.swal2-container') as HTMLElement; if (c) c.style.zIndex = '99999'; }
            });
            this.loadQueue();
            this.closePreview();
          },
          error: (err) => Swal.fire('Error', err.error?.message || 'Action failed', 'error')
        });
      }
    });
  }

  requestReupload(profileId: string): void {
    Swal.fire({
      title: 'Request Aadhaar Re-upload?',
      text: 'This will request the user to re-upload their document.',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes, Request',
      confirmButtonColor: '#0dcaf0',
      didOpen: () => {
        const container = document.querySelector('.swal2-container') as HTMLElement;
        if (container) container.style.zIndex = '99999';
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.adminService.requestReupload(profileId).subscribe({
          next: () => {
            Swal.fire({ title: 'Requested', text: 'User has been asked to re-upload Aadhaar.', icon: 'success',
              didOpen: () => { const c = document.querySelector('.swal2-container') as HTMLElement; if (c) c.style.zIndex = '99999'; }
            });
            this.loadQueue();
            this.closePreview();
          },
          error: (err) => Swal.fire('Error', err.error?.message || 'Action failed', 'error')
        });
      }
    });
  }

  getInitials(user: any): string {
    const first = user.basic_info?.first_name?.charAt(0) || '';
    const last = user.basic_info?.last_name?.charAt(0) || '';
    return (first + last).toUpperCase() || '?';
  }

  getAge(dob: string): number | string {
    if (!dob) return 'N/A';
    const birth = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  }

  zoomIn(): void {
    this.zoomLevel = Math.min(this.zoomLevel + 0.2, 2.5);
  }

  zoomOut(): void {
    this.zoomLevel = Math.max(this.zoomLevel - 0.2, 0.5);
  }

  resetZoom(): void {
    this.zoomLevel = 1.0;
  }

  onImageError(): void {
    this.imageError = true;
  }

  openPhotoLightbox(userId: string): void {
    const url = this.base64Images[userId];
    if (url) {
      this.photoLightboxUrl = url;
    }
  }

  closePhotoLightbox(): void {
    this.photoLightboxUrl = null;
  }

  getCaste(user: any): string {
    const c = user?.religion_info?.caste_id;
    return c?.caste_nme || (typeof c === 'string' ? c : '') || '—';
  }

  getSubCaste(user: any): string {
    const sc = user?.religion_info?.sub_caste_id;
    return sc?.subcaste_nme || (typeof sc === 'string' ? sc : '') || '—';
  }

  getNakshatra(user: any): string {
    const n = user?.religion_info?.natchr_id;
    return n?.nakshatra_nme || (typeof n === 'string' ? n : '') || '—';
  }

  getRasi(user: any): string {
    const r = user?.religion_info?.rasi_id;
    return r?.rasi_nme || (typeof r === 'string' ? r : '') || '—';
  }

  getGothram(user: any): string {
    const g = user?.religion_info?.gothrm_id;
    return g?.gothram_nme || (typeof g === 'string' ? g : '') || user?.religion_info?.dosham || '—';
  }

  getLocation(user: any): string {
    if (!user?.residing_location) return '—';
    const loc = user.residing_location;
    const city = loc.city_id?.city_nme || (typeof loc.city_id === 'string' ? loc.city_id : '');
    const dist = loc.dist_id?.district_nme || (typeof loc.dist_id === 'string' ? loc.dist_id : '');
    const state = loc.state_id?.state_nme || loc.state_id?.name_1 || (typeof loc.state_id === 'string' ? loc.state_id : '');
    const country = loc.country_id?.country_nme || (typeof loc.country_id === 'string' ? loc.country_id : '');
    const pin = loc.zipcode ? ` - ${loc.zipcode}` : '';
    const parts = [city, dist, state, country].filter(Boolean);
    return parts.length > 0 ? parts.join(', ') + pin : '—';
  }

  getEducation(user: any): string {
    const edu = user?.professional_info?.education_id;
    const detail = user?.professional_info?.education_detail;
    const name = edu?.education_nme || (typeof edu === 'string' ? edu : '');
    return [name, detail].filter(Boolean).join(' - ') || '—';
  }

  getOccupation(user: any): string {
    const occ = user?.professional_info?.occupation_id;
    const detail = user?.professional_info?.occupation_detail;
    const name = occ?.occupation_nme || (typeof occ === 'string' ? occ : '');
    return [name, detail].filter(Boolean).join(' - ') || '—';
  }

  getIncome(user: any): string {
    const sal = user?.professional_info?.annual_salary;
    return sal ? `₹${Number(sal).toLocaleString('en-IN')} / year` : '—';
  }
}
